.z{align-items:center;}